import { Skeleton } from '@/_components/ui/skeleton'

export const SkeletonFormActions = () => {
  return (
    <div className="flex w-full justify-end gap-[10px]">
      <Skeleton className="h-9 w-24" />
      <Skeleton className="h-9 w-24" />
    </div>
  )
}
